import React, { useState, useEffect } from 'react';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { Trans } from 'react-i18next'
import dataStorage from 'dataStorage';

export default function DatePickerField(props) {
  const [field, meta, helper] = useField(props);
  const { touched, error } = meta;
  const { setValue } = helper;
  const isError = touched && error && true;
  const { value } = field;
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      setSelectedDate(date);
    } else {
      setSelectedDate(null);
    }
  }, [value]);

  function _onChange(date) {
    if (date == null) return
    if (date) {
      setSelectedDate(date);
      try {
        setValue(date, true);
      } catch (error) {
        setValue(date, true);
      }
    } else {
      setValue(date, true);
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        {...field}
        {...props}
        autoOk={true}
        // disableToolbar
        defaultCalendarMonth={props.maxDate || props.minDate}
        variant="inline"
        inputVariant="outlined"
        value={selectedDate}
        mask='____-__-__'
        onChange={_onChange}
        // onClose={_onClose}
        renderInput={(params) => <TextField
          // {...field}
          placeholder='yyyy-mm-dd'
          name={field.name}
          value={field.value}
          onBlur={field.onBlur}
          {...params}
          label={<Trans>{params.label}</Trans>}
          error={isError}
          helperText={isError && error ? <Trans values={{ label: dataStorage.translate(props.label) }}>{error}</Trans> : ''}
          fullWidth />}
      />
    </LocalizationProvider>
  );
}
